import script from "./HeaderReports.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderReports.vue?vue&type=script&setup=true&lang=js"

import "./HeaderReports.vue?vue&type=style&index=0&id=4b763f27&lang=css"

const __exports__ = script;

export default __exports__